(function ($) {
  Drupal.behaviors.ehThewinkSpecialIssuesFormatterV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-special-issues-formatter-v1', context),
        $theWinkSIHeroHeader = formatter.find('.eh-thewink-special-issues-hero-header');

      // Ensure we have the "section-thewink-redesign" body class and remove the "section-thewink" body class from the new "The Wink" 2.0 pages
      if (!$('body').hasClass('section-thewink-redesign') && $('body').hasClass('section-thewink')) {
        $('body').removeClass('section-thewink');
        $('body').addClass('section-thewink-redesign');
      }

      formatter.each(function () {
        var thisFormatter = $(this),
          $stickyBar = $('#sticky-bar'),
          lastScrollTop = 0;

        // Lazyload
        // site.util.lazyLoaded(thisFormatter);

        // Make the left column static position while page is down scrolling, then when hero height is reached fadeIn it into a "fixed" position
        if ($('body').hasClass('device-pc')) { // if (!site.client.isMobile && $('body').hasClass('device-pc')) {
          $(window).on('scroll', _.throttle(function () {
            var st = $(this).scrollTop();

            if (st > lastScrollTop) {
              // downscroll
              if ($theWinkSIHeroHeader.length && st >= $theWinkSIHeroHeader.height()) {
                thisFormatter.find('.col.left-side-col').removeClass('static').addClass('fixed').hide();
                if (!thisFormatter.find('.col.left-side-col').is(':visible')) {
                  thisFormatter.find('.col.left-side-col').stop().fadeIn(600, function () {
                    if (thisFormatter.find('.col.left-side-col').hasClass('fixed')) {
                      thisFormatter.find('.col.left-side-col').show();
                      thisFormatter.find('.col.left-side-col').stop(true, true);
                    }
                  });
                }
                thisFormatter.find('.si-thewink-logo-image').hide();
              } else {
                thisFormatter.find('.si-thewink-logo-image').show();
              }
            } else {
              // upscroll
              if (st <= 1000) {
                if (thisFormatter.find('.col.left-side-col').hasClass('fixed')) {
                  thisFormatter.find('.col.left-side-col').removeClass('fixed').addClass('static');
                  thisFormatter.find('.si-thewink-logo-image').show();
                }
              }
            }
            lastScrollTop = st;
          }, 100)); // $(window).on(scroll)
          // Put "The Wink" 2.0 menu (non-sticky) on a fixed position for the "Special Issues" section only
          if (!$('#sticky-bar').hasClass('thewink-sticky-bar')) {
            $('body').addClass('thewink-special-issues');
          }
        }

        // Remove left/right-col for mobile
        if ($('body').hasClass('device-mobile')) { // if (site.client.isMobile && $('body').hasClass('device-mobile')) {
          thisFormatter.find('.col').removeClass('static').addClass('fixed');
          // Offers promo MUST be hidden on for the mobile nav to work
          $('.nav-promo, .offer-promo').hide();
          thisFormatter.find('.cols .left-side-col').removeClass('left-side-col');
          thisFormatter.find('.cols .right-side-col').removeClass('right-side-col');
          // Reposition hero on mobile
          var $cols = thisFormatter.find('.cols'),
            $colFirst = $cols.find('.col.first'),
            $col = $cols.find('.col'),
            $heroFormatter = $col.find('.eh-thewink-special-issues-hero-header'),
            $colFirstClone = $colFirst.clone(),
            $contentWrapper = $heroFormatter.find('.content-wrapper'),
            $editorsLetter = $contentWrapper.clone(),
            $theWinkMenu = $col.find('.eh-thewink-hp-redesign-menu-formatter'),
            $theWinkMenuHeader = $theWinkMenu.find('.thewink-mobile-header'),
            $theWinkMenuLogo = $theWinkMenuHeader.find('.thewink-logo'),
            $siTitle = $col.find('.si-title');

          $contentWrapper.hide();
          $colFirstClone.insertAfter($colFirst.next().next()).show();
          $editorsLetter.insertAfter($colFirst.next().next().next()).show();
          $colFirstClone.removeClass('first fixed');
          $colFirstClone.find('.si-thewink-logo-image').hide();
          $cols.find('.col.fixed.first').remove();
          // Hide the new "The Wink" 2.0 (non-sticky) menu on mobile
          $col.find('.special-issues-formatter').find('.eh-thewink-hp-redesign-menu-formatter').hide();
          $col.find('.special-issues-formatter').find('.eh-thewink-hp-redesign-menu-formatter').hide();
          $('<p class="mobile-logo-special-issues">Special Issues: ' + $siTitle.text() + '</p>').insertAfter($theWinkMenuLogo.find('img')).css({ 'color': $siTitle.css('color') });
          // $theWinkMenuHeader.css({'overflow':'auto'});
          // $theWinkMenuLogo.css({'max-width':'none'}).find('img').css({'margin-bottom':'5px'});
        }
      });
    }
  };
/*
  // Custom throttle
  // On mobile, _.throttle and .throttle are failing
  function throttle(func, delay) {
    var timer = 0;

    return function() {
      var context = this,
          args    = [].slice.call(arguments);

      clearTimeout(timer);
      timer = setTimeout(function() {
        func.apply(context, args);
      }, delay);
    };
  }
//*/
})(jQuery);
